import Axios from 'axios';
import * as humps from 'humps';
import authClient from './useAuthClient';
import useAuthActions from './useAuthActions';

export default ({state, dispatch}) => {
  const authActions = useAuthActions({ state, dispatch });

  const hellomailClient = Axios.create({
    baseURL: process.env.REACT_APP_HELLOMAIL_API_URL || '',
    transformRequest: [
      (data) => {
        return data instanceof FormData ? data : humps.decamelizeKeys(data);
      },
      ...(Axios.defaults.transformRequest)
    ],
    transformResponse: [
      ...(Axios.defaults.transformResponse),
      (data) => {
        if (data instanceof Blob) {
          return data;
        } else {

          const protectedKeys = ['builder_config'];

          const leaveObject = {};
          const adjustObject = Object.keys(data).reduce((o,k) => {
            if (protectedKeys.includes(k)) {
              leaveObject[k] = data[k];
              return {...o};
            } else {
              return {...o, [k]: data[k]};
            }
          }, {});

          return {...leaveObject, ...humps.camelizeKeys(adjustObject) };
        }
      }
    ],
    headers: {
      "Content-Type": "application/json",
      'Authorization': `Bearer ${state.user.jwt}`
    }
   });

  const suspendUntilReauthenticated = () => {
    const { isReauthenticating } = state.user;
  
    if (!isReauthenticating) return;
  
    return new Promise(resolve => {
      // const unsubscribe = store.subscribe(() => {
      //   const { isReauthenticating } = store.getState().user;
  
      //   if (!isReauthenticating) {
      //     resolve();
      //     unsubscribe();
      //   }
      // });
    });
  }

   hellomailClient.interceptors.response.use(
    response => response,
    async (error) => {
  
      const isAccessTokenExpired = error.response.status === 401 && state.user.jwt;
  
      if (!!isAccessTokenExpired) {
        // If there are some simultaneous requests when accessToken is expired,
        // we want to reauthenticate only after the first failure.
        // So, we suspend retry until the session is reauthenticated.
        if (state.user.isReauthenticating) {
          await suspendUntilReauthenticated();
        } else {
  
          authActions.cookieSignIn();
  
          try {
            const payload = await authClient.cookieSignIn();
            const { user, token: jwt } = payload;
            const { email, firstName, lastName, sites, siteId } = user;
  
            authActions.signInSucceeded({
              firstName,
              lastName,
              email,
              sites,
              siteId,
              jwt
            });
          } catch (error) {
            authActions.signInFailed();
            throw error;
          }
        }
  
        const requestWithNewToken = {
          ...error.config,
          headers: {
            ...error.config.headers,
            Authorization: `Bearer ${state.user.jwt}`
          }
        };
  
        return hellomailClient(requestWithNewToken);
      }
  
      throw error;
    }
  );

   return hellomailClient;
}